<template>
  <div class="confirm_order_detail">
    <div class="bg"></div>
    <div class="confirm_order_warp">
      <div class="confirm_order_ordertitle">
        <img src="../../assets/image/orderdetail_pay@3x.png" alt />
        <div class="div1">
          <p class="p1">等待付款</p>
          <p class="p2">您的订单已经生成，等待付款~</p>
        </div>
      </div>
      <!-- 订单失效倒计时 -->
      <div class="countdown" v-if="isCountdownShow && orderObj.templateStatus == 0">
        <div class="image">
          <img src="@/assets/countdown.png" alt="">
        </div>
        <div class="content">
          <div class="timing">
            <span class="text">距离订单失效</span>
            <span class="time">{{ templateFinishTime }}</span>
          </div>
          <div class="tip">亲，该宝贝正一步步远离你哦，请抓紧时间买Ta吧</div>
        </div>
      </div>
      <div
        class="confirm_order_address"
        v-show="$route.query.type && $route.query.type=='user'"
        @click="toAddressFun"
      >
        <img src="../../assets/image/icon_add@3x.png" alt />
        <div class="div1">
          <p class="p1">{{addressObj.userName}} {{addressObj.mobile}}</p>
          <p class="p2">{{addressObj.areaName}}{{addressObj.addressDetail}}</p>
        </div>
      </div>
      <!-- 订单失效 -->
      <div class="failure" v-if="orderObj.templateStatus && orderObj.templateStatus == 1 && !isCountdownShow">
        <div>
          <img src="@/assets/exclamation_red@2x.png" alt="">
          <span>该订单已失效</span>
        </div>
      </div>
      <div
        class="confirm_order_goodsitem"
        v-for="(item,index) in orderObj.appSubOrderDetailVoList"
        :key="index"
      >
        <div class="brand_name">
          <img src="../../assets/image/brand.png" alt />
          <p>{{item.shopName}}</p>
          <img src="../../assets/image/arrow_icon@2x.png" alt />
        </div>
        <div class="brand_goods" v-for="(t,idx) in item.appSubOrderItemDetailVoList" :key="idx">
          <div class="brand_goods_info">
            <van-image
              width="70"
              height="70"
              fit="cover"
              :src="t.hangTagImageInfoUrl+'?x-oss-process=style/style_myorder_list_img'"
            ></van-image>
            <div class="info">
              <div class="div1">
                <p class="p1">{{t.goodsName}}</p>
                <p class="p2">￥{{t.goodsPrice}}</p>
              </div>
              <div class="div1">
                <p class="p3">{{t.attributeValues}}</p>
                <p class="p4">x{{t.goodsCount}}</p>
              </div>
            </div>
          </div>
          <div class="px">
            <div class="infop1 mr-10">
              <div class="si col9" v-if="t.afterTemplate == 'UNRETURNABLE'" @click="$toast('该商品为特殊商品（秒杀、特价、大件等），不支持退换货，请确认后下单')">
                <van-icon style="vertical-align:middle;" name="warning-o" />该商品不支持退换货
              </div>
            </div>
            <div class="brand_goods_price">
              <span>
                ￥
                <span style="color:#333;">{{(t.goodsPrice *100) * t.goodsCount / 100}}</span>
              </span>
              <span class="red" v-show="t.modifyPrice">改价 ￥{{t.modifyPrice}}</span>
            </div>
          </div>
          <div class="brand_goods_images">
            <div class="brand_goods_image_one" @click="showMaxImgFun(t.skuImageInfoUrlList)">
              <van-image :src="t.skuImageInfoUrlList[0]" fit="cover" width="150" height="200" class></van-image>
              <span class="span">1/{{t.skuImageInfoUrlList.length}}</span>
            </div>
            <div class="brand_goods_image_one">
              <van-image :src="t.hangTagImageInfoUrl" fit="cover" width="150" height="200"></van-image>
            </div>
          </div>
        </div>
      </div>
      <div class="confirm_order_footer">
        <span>共 {{orderObj.totalCount}} 件商品，共计</span>
        <span class="price">￥{{orderObj.totalGoodsPrice}}</span>
      </div>
      <div class="confirm_order_info">
        <div class="item">
          <p>下单时间:</p>
          <p>{{orderObj.createTime}}</p>
        </div>
        <div class="item">
          <p>商品总额:</p>
          <p>￥{{orderObj.totalGoodsPrice}}</p>
        </div>
        <div class="item">
          <p>运费:</p>
          <p style="color:#ED3939;" v-if="orderObj.appSubOrderDetailVoList[0].freeShippingType == 'e'">到付</p>
          <p v-else>￥{{orderObj.totalFrightPrice}}</p>
        </div>
        <div class="item" v-if="orderObj.platformDiscountPrice">
          <p>优惠券:</p>
          <p>-￥{{orderObj.platformDiscountPrice}}</p>
        </div>
        <div class="item" v-if="orderObj.appSubOrderDetailVoList[0] != 'e' && orderObj.frightCouponValue">
          <p>运费券:</p>
          <p>-￥{{orderObj.frightCouponValue}}</p>
        </div>
        <div class="itemPrice">
          <p>
            待付款
            <span>￥{{orderObj.actualPrice}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="footer" v-show="$route.query.type && $route.query.type=='user'">
      <span @click="createOrderFun">付款</span>
    </div>
  </div>
</template>
<script>
import Util from "@/utils/common";
export default {
  data() {
    return {
      addressObj: {
        userName: "",
        mobile: "",
        areaName: "",
        addressDetail: "",
        addressId: ""
      },
      templateid: "",
      orderObj: {},
      isBtn: true,
      templateFinishTime: '',
      templateFinishTimeText: '',
      isCountdownShow: false,
    };
  },
  methods: {
    init() {
      this.$loading.hide();
      this.templateid = this.$route.query.tempId;
      if (this.$route.query.type == "user") {
        this.getAddress();
      } else {
        this.onGetTemplateDetail(this.templateid);
      }
    },
    // 获取默认地址
    getAddress() {
      this.http({
        url: "base/user/address/findDefault",
        method: "post"
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data && rps.data.id) {
            this.addressObj = {
              userName: rps.data.userName,
              mobile: rps.data.mobile,
              areaName: rps.data.areaName,
              addressDetail: rps.data.addressDetail,
              addressId: rps.data.id
            };
            this.onGetTemplateDetail(this.templateid, rps.data.id);
          } else {
            this.onGetTemplateDetail(this.templateid);
          }
        } else {
          this.onGetTemplateDetail(this.templateid);
        }
      });
    },
    // 获取模板数据
    onGetTemplateDetail(templateId, addressId) {
      this.http({
        url: "order/appOrder/orderTemplateDetail",
        method: "post",
        parmes: {
          templateId: templateId,
          addressId: addressId || ""
        }
      }).then(rps => {
        if (rps.code == 200) {
          this.$loading.hide();
          this.orderObj = rps.data;
          if (rps.data.templateFinishTime && rps.data.templateStatus == 0) {
            this.templateFinishTimeText = rps.data.templateFinishTime
            this.countDown()
          } else if (rps.data.templateStatus == 1) {
            this.isCountdownShow = false
          }
        }
      });
    },
    //订单模板，创建订单
    createOrderFun() {
      if (this.addressObj && this.addressObj.addressId) {
        if (this.isBtn) {
          this.isBtn=false;
          this.http({
            url: "order/bees/quickOrder/template/createOrder",
            method: "post",
            parmes: {
              address: this.addressObj.addressDetail,
              addressId: this.addressObj.addressId,
              deliveryType: "EXPRESS",
              mobile: this.addressObj.mobile,
              templateId: this.templateid,
              userCouponId: this.orderObj.userCouponId,
              userFrightCouponId: this.orderObj.userFrightCouponId,
              userName: this.addressObj.userName
            }
          }).then(rps => {
            if (rps.code === 200) {
              this.doPay(rps.data);
            }
          });
        }
      } else {
        this.$toast("请选择地址");
      }
    },
    //付款
    doPay(id) {
      this.isBtn=true;
      if (window.isApp == "IOS") {
        window.webkit.messageHandlers.pushPaymentViewController.postMessage({
          orderId: id
        });
      } else {
        window.beego.callPay(id);
      }
    },
    // 点击放大图片
    showMaxImgFun(list) {
      Util.showMaxImg(encodeURIComponent(JSON.stringify(list)), 0);
    },
    // 去我的地址
    toAddressFun() {
      this.$router.push({ path: "/myaddress" });
    },
    //检验是否已经生成了订单
    checkTemplateId() {
      this.http({
        url: "order/appOrder/common/getOrderIdByOrderTemplateId",
        method: "post",
        parmes: {
          orderTemplateId: this.$route.query.tempId
        }
      }).then(rps => {
        if (rps.code == 200 && rps.data) {
          if (this.$route.query.type == "user") {
            this.$router.replace({
              path: "/orderDetail",
              query: { orderId: rps.data}
            });
          } else {
            this.$router.replace({
              path: "/beesOrderDetail",
              query: { orderId: rps.data }
            });
          }
        } else {
          this.init()
        }
      });
    },
    /**
     * 倒计时函数
     */
    countDown() {
      let time = this.templateFinishTimeText.replace(/-/g, '/')
      let newTime = new Date().getTime()  // 当前时间
      let endTime = new Date(time).getTime()  // 结束时间
      if (endTime > newTime) {
        let time = (endTime - newTime) / 1000
        let hou = this.timeFormat(parseInt(time % (60 * 60 * 24) / 3600))
        let min = this.timeFormat(parseInt(time % (60 * 60 * 24) % 3600 / 60))
        let sec = this.timeFormat(parseInt(time % (60 * 60 * 24) % 3600 % 60))
        let templateFinishTime = hou + ':' + min + ':' + sec
        this.templateFinishTime = templateFinishTime
        this.isCountdownShow = true
        setTimeout(this.countDown, 1000)
      } else {
        this.checkTemplateId()
      }
    },
    /**
     * 小于10的格式化函数
     */
    timeFormat(param) {
      return param < 10 ? '0' + param : param;
    }
  },
  created() {
    this.checkTemplateId();
  }
};
</script>
<style lang="less" scoped>
.confirm_order_detail {
  .bg {
    background: #f8d541;
    height: 126px;
    width: 100%;
    position: relative;
  }
  .confirm_order_warp {
    padding: 40px 30px;
    margin-top: -120px;
    position: relative;
    margin-bottom: 100px;
    .confirm_order_ordertitle {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 30px 20px;
      color: #333;
      img {
        width: 100px;
      }
      .div1 {
        padding-left: 20px;
        box-sizing: border-box;
        .p1 {
          font-size: 32px;
          padding-bottom: 10px;
        }
        .p2 {
          font-size: 24px;
        }
      }
    }
    .countdown {
      display: flex;
      align-items: center;
      height: 140px;
      background-color: #fff;
      border-radius: 20px;
      margin-top: 20px;
      padding-left: 40px;
      .image {
        width: 80px;
        height: 80px;
        margin-right: 20px;
        >img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 80px;
        .timing {
          display: flex;
          align-items: center;
          .text {
            font-size: 26px;
            color: #333333;
            font-weight: 700;
            margin-right: 20px;
          }
          .time {
            font-size: 30px;
            font-weight: 500;
            color: #ED3939;
          }
        }
      }
      .tip {
        font-size: 24px;
        color: #999999;
      }
    }
    .failure {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      background-color: #FFEDEE;
      border-radius: 10px;
      color: #ED3939;
      margin-bottom: 20px;
      margin-top: 20px;
      >div {
        display: flex;
        align-items: center;
        >span {
          font-size: 26px;
          font-weight: 500;
          margin-left: 10px;
          line-height: 32px;
        }
        >img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .confirm_order_address {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      margin-top: 20px;
      padding: 40px;
      color: #333;
      img {
        width: 80px;
      }
      .div1 {
        padding-left: 20px;
        box-sizing: border-box;
        .p1 {
          font-size: 26px;
          padding-bottom: 10px;
        }
        .p2 {
          font-size: 24px;
          color: #999;
        }
      }
    }
    .confirm_order_goodsitem {
      background: #fff;
      border-radius: 20px 20px 0 0;
      margin-top: 20px;
      color: #333;
      .brand_name {
        font-size: 26px;
        color: #333;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f2f2f2;
        padding: 15px 30px;
        img {
          width: 40px;
          height: 40px;
          padding: 0 10px;
          &:first-child {
            padding-left: 0;
          }
        }
      }
      .brand_goods {
        padding: 0 30px;
        .brand_goods_info {
          display: flex;
          align-items: center;
          padding: 30px 0;
          img {
            width: 70px;
            height: 70px;
            padding-right: 10px;
          }
          .info {
            flex: 1;
            padding-left: 15px;
            box-sizing: border-box;
            .div1 {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 10px 0;
              // &:last-child{
              //   padding: 20px 0;
              // }
              .p1 {
                font-size: 26px;
                color: #333;
                width: 324px;
              }
              .p2 {
                font-size: 26px;
                color: #999;
              }
              .p3 {
                font-size: 24px;
                color: #999;
              }
              .p4 {
                font-size: 26px;
                color: #999;
              }
            }
          }
        }
        .brand_goods_price {
          border-bottom: 1px solid #f2f2f2;
          text-align: right;
          color: #999;
          font-size: 26px;
          .red {
            color: #ed3939;
          }
        }
        .brand_goods_images {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .brand_goods_image_one {
            &:first-child {
              position: relative;
            }
            .van-image {
              display: block;
            }
            span {
              position: absolute;
              bottom: 0;
              left: 0;
              font-size: 24px;
              color: #ccc;
              display: inline-block;
              width: 100%;
              text-align: center;
              padding: 10px 0;
              background: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
    }
    .confirm_order_footer {
      padding: 20px 30px;
      text-align: right;
      border-radius: 0 0 20px 20px;
      background-color: #fff;
      font-size: 26px;
      color: #999;
      .price {
        color: #333;
      }
    }
    .confirm_order_info {
      padding: 40px;
      margin-top: 20px;
      font-size: 24px;
      border-radius: 20px;
      color: #333;
      background-color: #fff;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
      }
      .itemPrice {
        padding: 5px 0;
        text-align: right;
        color: #999;
        font-size: 26px;
        span {
          color: #ed3939;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: right;
    padding: 20px 30px;
    background-color: #fff;
    box-sizing: border-box;
    span {
      background-color: #f8d541;
      font-size: 24px;
      color: #333;
      width: 160px;
      border-radius: 30px;
      text-align: center;
      padding: 13px 0;
      display: inline-block;
    }
  }
}
.px {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;
}
.infop1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 26px;
  span {
    color: #999;
  }
  strong {
    color: #333;
  }
  .si {
    font-size: 18px;
  }
  .col9 {
    color: #999999;
  }
}
</style>